import { render } from "./GraphIconColor.vue?vue&type=template&id=0709c3a4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/GraphIconColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0709c3a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0709c3a4', __exports__)) {
    api.reload('0709c3a4', __exports__)
  }
  
  module.hot.accept("./GraphIconColor.vue?vue&type=template&id=0709c3a4", () => {
    api.rerender('0709c3a4', render)
  })

}


export default __exports__